import styled from '@emotion/styled';
import React from 'react';

import PaymentsIconSrc from '~Assets/icons/payments.svg';
import PrinterIconSrc from '~Assets/icons/print.svg';
import ForwardArrowSrc from '~Assets/icons/arrow_forward.svg';
import BackArrowSrc from '~Assets/icons/arrow_back.svg';
import CheckIconSrc from '~Assets/icons/check.svg';
import CogWheelIconSrc from '~Assets/icons/settings.svg';
import LayoutIconSrc from '~Assets/icons/edit_layout.svg';
import KitchenTicketSrc from '~Assets/icons/receipt_long.svg';
import StaffIconSrc from '~Assets/icons/person.svg';
import ReceiptIconSrc from '~Assets/icons/receipt.svg';
import RestaurantIconSrc from '~Assets/icons/restaurant.svg';

import { COLORS } from '../styles';

const IconWrapper = styled.div<{ margin?: string }>`
  width: 32px;
  height: 32px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: ${({ margin }) => margin || '0 0 0 0'};
`;

const IconDiv = styled.div<{
  src: string;
  width?: number;
  height?: number;
  color?: string;
}>`
  width: ${({ width }) => width || 24}px;
  height: ${({ height }) => height || 24}px;
  mask-image: url(${({ src }) => src});
  mask-size: contain;
  mask-repeat: no-repeat;
  background: ${({ color }) => color ?? 'var(--colorBlueGray100)'};
`;

export enum IconType {
  PRINTER = 'printer',
  PAYMENTS = 'payments',
  CHECK = 'check',
  FORWARD_ARROW = 'forward_arrow',
  BACK_ARROW = 'back_arrow',
  COG_WHEEL = 'cog_wheel',
  LAYOUT_CHANGE = 'layout_changed',
  KITCHEN_TICKET = 'kitchen_ticket',
  STAFF = 'staff',
  RECEIPT = 'receipt',
  RESTAURANT = 'restaurant',
}

export type Icon = {
  type: IconType;
  bgColor: string;
  color?: keyof typeof COLORS;
  margin?: string;
  width?: number;
  height?: number;
  onClick?: () => void;
};

const IconSrc: Record<IconType, string> = {
  [IconType.PRINTER]: PrinterIconSrc,
  [IconType.PAYMENTS]: PaymentsIconSrc,
  [IconType.FORWARD_ARROW]: ForwardArrowSrc,
  [IconType.BACK_ARROW]: BackArrowSrc,
  [IconType.CHECK]: CheckIconSrc,
  [IconType.COG_WHEEL]: CogWheelIconSrc,
  [IconType.LAYOUT_CHANGE]: LayoutIconSrc,
  [IconType.KITCHEN_TICKET]: KitchenTicketSrc,
  [IconType.STAFF]: StaffIconSrc,
  [IconType.RECEIPT]: ReceiptIconSrc,
  [IconType.RESTAURANT]: RestaurantIconSrc,
};

const RoundedIcon = ({ type, bgColor, color, height, width, margin, onClick }: Icon) => {
  return (
    <IconWrapper style={{ background: bgColor }} onClick={onClick} margin={margin}>
      <IconDiv src={IconSrc[type]} height={height} width={width} color={color} />
    </IconWrapper>
  );
};

export default RoundedIcon;
